import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from '@/auth/useSession';
import { Spinner } from '@/components/ui';

export function Splash() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-3 text-stone-700">
      <img src="/icons/icon-192.png" alt="" className="h-16 w-16 rounded-2xl" />
      <Spinner />
      <span>{t('app.loading')}</span>
    </div>
  );
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const s = useSession();
  if (s.status === 'loading') return <Splash />;
  if (s.status === 'signedOut') return <Navigate to="/login" replace />;
  return <>{children}</>;
}

/** Owner-only screens (PL-4 — the UI hides what the role cannot do; the server enforces it). */
export function RequireOwner({ children }: { children: ReactNode }) {
  const s = useSession();
  if (s.profile?.role !== 'OWNER') return <Navigate to="/" replace />;
  return <>{children}</>;
}
